module.exports = __webpack_public_path__ + "img/qyjy2.627a2bc9.png";